import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Typography, Box, Container, Button } from '@mui/material';
import StatementsActions from './StatementsActions';
import useStyles from './styles';
export default function StatementsBatchActions(props) {
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _props$selectCount = props.selectCount,
    selectCount = _props$selectCount === void 0 ? 0 : _props$selectCount,
    _props$handleBatchDes = props.handleBatchDeselect,
    handleBatchDeselect = _props$handleBatchDes === void 0 ? () => {} : _props$handleBatchDes;
  return /*#__PURE__*/React.createElement(Box, {
    className: classes.batchBarWrapper
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    className: classes.batchBarContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.selectInfo
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    onClick: handleBatchDeselect,
    'custom-attribute': '427-StatementsBatchActions'
  }, t('general.deselect_all')), /*#__PURE__*/React.createElement("div", {
    className: classes.selectCount
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, selectCount, /*#__PURE__*/React.createElement("span", null, selectCount > 1 ? t('residencies_page.statements_selected') : t('residencies_page.statement_selected'))), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light"
  }, t('residencies_page.select_multiply_lines')))), /*#__PURE__*/React.createElement(StatementsActions, null))));
}
StatementsBatchActions.propTypes = {
  selectCount: PropTypes.number,
  handleBatchDeselect: PropTypes.func
};